module.exports = __webpack_public_path__ + "img/ic_buy4you.5efb4c45.svg";